import { render, staticRenderFns } from "./NextSessionBar.vue?vue&type=template&id=abbef3fa&scoped=true&"
import script from "./NextSessionBar.vue?vue&type=script&lang=js&"
export * from "./NextSessionBar.vue?vue&type=script&lang=js&"
import style0 from "./NextSessionBar.vue?vue&type=style&index=0&id=abbef3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbef3fa",
  null
  
)

export default component.exports